<dms-table [tableConfig]="tableConfig"
           [commonConfig]="commonConfig"
           [tableData]="tableData"
           [isWebView]="isWebView"
           [filterValue]="filterValue"
           (selectedRow)="rowSelected($event)"
           (action)="gridAction($event)" #fileTable>
</dms-table>
